import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useResizeHandle } from '../workspace-common/components';
import { ResizeHandle } from '../workspace-common/components';
import {
  DEFAULT_LEFT_SIDEBAR_WIDTH,
  DEFAULT_RIGHT_SIDEBAR_WIDTH,
} from '../workspace-common/constants';
import { NoteListSidebarSupervisor } from './components/NoteListSidebarSupervisor/NoteListSidebarSupervisor';
import { ReviewAnnotationsSidebar } from './components/ReviewAnnotationsSidebar/ReviewAnnotationsSidebar';
import { SupervisorContent } from './components/SupervisorContent/SupervisorContent';
import { selectShowAnnotations } from './state/selector';
import { useAppDispatch, useAppSelector } from '../../lib/store';
import { selectBatchId } from '../supervisor-queue/state/selector';
import { setBatchId } from '../supervisor-queue/state/supervisorQueueSlice';

export const SupervisorScreen = () => {
  const {
    startLeftResize,
    startRightResize,
    rightWidth,
    leftWidth,
    setRightInitialWidthToDefault,
    setLeftInitialWidthToDefault,
  } = useResizeHandle({
    initialLeftWidth: DEFAULT_LEFT_SIDEBAR_WIDTH,
    initialRightWidth: DEFAULT_RIGHT_SIDEBAR_WIDTH,
    minRightWidth: DEFAULT_RIGHT_SIDEBAR_WIDTH,
  });
  const showAnnotations = useAppSelector(selectShowAnnotations);

  // batchId is passed via the ?batchId= query param (see useSupervisorQueueContent) so it
  // survives a page refresh, which resets the supervisorQueue Redux slice to null. Re-sync
  // it into Redux here, and hold off mounting children until it's in sync, so the workspace
  // query hooks below (which read batchId from Redux) never fire with a stale/null batchId.
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const batchId = useAppSelector(selectBatchId);
  const batchIdFromUrl = searchParams.get('batchId');

  useEffect(() => {
    if (batchIdFromUrl && batchIdFromUrl !== batchId) {
      dispatch(setBatchId(batchIdFromUrl));
    }
  }, [batchIdFromUrl, batchId, dispatch]);

  if (batchIdFromUrl && batchIdFromUrl !== batchId) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <NoteListSidebarSupervisor leftWidth={leftWidth} />
      <ResizeHandle onMouseDown={(e: React.MouseEvent) => startLeftResize(e)} />
      <SupervisorContent />
      {showAnnotations && (
        <ResizeHandle onMouseDown={(e: React.MouseEvent) => startRightResize(e)} />
      )}
      <ReviewAnnotationsSidebar rightWidth={rightWidth} />
    </Box>
  );
};
